import { FC } from "react"

import { useGetClientPaymentMethods } from "modules/ClientAccount/hooks"
import { PaymentMethodNoCard } from "modules/ClientAccount/components/PaymentMethodNoCard"
import { PaymentMethodWithCard } from "modules/ClientAccount/components/PaymentMethodWithCard"

export const PaymentMethodWrapper: FC = () => {
    const { data = [], refetch } = useGetClientPaymentMethods()

    return (
        <>
            {data.length > 0 ? (
                <PaymentMethodWithCard cards={data} reFetchCardList={() => void refetch()} />
            ) : (
                <PaymentMethodNoCard reFetchCardList={() => void refetch()} />
            )}
        </>
    )
}
